import React from "react";
import { WEEKDAYS, toLocalDateKey } from "../../../utils/datetime";
import { ScheduledMatch } from "./matchLayout";

interface WeekDaysGridProps {
  weekDays: Date[];
  selectedDayKey: string;
  matchesByDay: Map<string, ScheduledMatch[]>;
  onSelectDay: (dayKey: string) => void;
}

// Griglia dei 7 giorni della settimana; ogni giorno con match è selezionabile e
// mostra il numero di partite.
export const WeekDaysGrid: React.FC<WeekDaysGridProps> = ({
  weekDays,
  selectedDayKey,
  matchesByDay,
  onSelectDay,
}) => (
  <section className="rounded border border-gray-300 bg-white p-3 shadow-sm sm:p-5">
    <div className="grid grid-cols-7 border-l border-t border-gray-300">
      {weekDays.map((day, index) => {
        const dayKey = toLocalDateKey(day);
        const dayMatches = matchesByDay.get(dayKey) ?? [];
        const isSelectable = dayMatches.length > 0;
        const isSelected = selectedDayKey === dayKey;
        return (
          <button
            key={dayKey}
            type="button"
            disabled={!isSelectable}
            onClick={() => onSelectDay(dayKey)}
            className={`border-r border-b border-gray-300 p-2 text-center transition-colors ${
              isSelected
                ? "bg-blue-50 text-blue-900"
                : isSelectable
                  ? "bg-white text-gray-900 hover:bg-gray-50"
                  : "cursor-default bg-gray-50 text-gray-400"
            }`}
          >
            <div className="text-xs font-semibold">{WEEKDAYS[index]}</div>
            <div className="text-sm font-bold">{day.getDate()}</div>
            {isSelectable ? (
              <div className="mt-1 inline-flex min-w-6 justify-center rounded bg-blue-100 px-2 py-1 text-xs font-semibold text-blue-800">
                {dayMatches.length}
              </div>
            ) : null}
          </button>
        );
      })}
    </div>
  </section>
);
